import React from 'react';
import { Button, Flex, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { setShowBreaksModal } from '../../../../redux/thread/threadSlice';

const BreaksModal = ({ open, onClose, onTakeShortWalk, onTakeBreathing }) => {

  const dispatch = useDispatch();
  
  return (
    <Modal
      centered
      classNames={{ content: '!bg-white' }}
      width={500}
      open={open}
      onOk={() => {}}
      onCancel={() => {}}
      footer={[]}
      closable={false}
      maskClosable={false}
    >
      <h2 className="mb-0 font-bold">Small Breaks, Big Impact</h2>
      <p className="text-gray-600">
        Just like working out a muscle, your mind needs breaks too. Taking a moment to breathe, stretch, or step away can help everything sink in.
      </p>

      <Flex vertical gap="middle" className="mx-auto mt-8 max-w-xs">
        <Button block size="large" shape="round" type="default" className="!bg-white" onClick={onTakeShortWalk}>
          Take a Short Walk (5 mins)
        </Button>
        <Button block size="large" shape="round" type="default" className="!bg-white" onClick={onTakeBreathing}>
          Guided Breathing (2 mins)
        </Button>
        <Button type="primary" block size="large" shape="round" onClick={() => dispatch(setShowBreaksModal(false))}>
          Keep Chatting
        </Button>
      </Flex>

      <p className="mt-8 text-gray-500 text-center">
        Tip: A small reset can help you get even more out of this session.
      </p>
    </Modal>
  );
};

export default BreaksModal;





